import React, { useState, useEffect } from 'react'
import { Grid, Typography, Box, Container, Divider, Link as LinkText } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
// import Tooltip from '@mui/material/Tooltip'
import ButtonTooltip from 'components/Common/ToolTip/ButtonTooltip'
import Tooltip from 'components/Common/ToolTip'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import GoogleMapReact from 'google-map-react'
import { useNavigate } from 'react-router-dom'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import ZendeskLink from 'components/Common/ZendeskLink'
import './index.css'
import CompanyOverview from './CompanyOverview'
import FinancialComponent from './Financials'
import MarkaazBusinessComponent from './MarkaazBusiness'
import HealthMetricsComponent from './HealthMetrics'
import KeyPeople from './KeyPeoples'
import SocialComponent from './Social'
import { updateMonitoredBusiness, handleNotifications } from 'store/actions/businessListingActions'
import MainLayout from 'layouts/mainLayout'
import { styled } from '@mui/material/styles'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
// import IdleTimer from 'components/Common/IdleTimer'
import Button from 'components/Common/Button'
import { DISABLED_BUTTON, PRIMARY_BUTTON } from 'themes/theme'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import { Button as MuiButton } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import DollarSignImg from 'assets/business/fi_dollar-sign.svg'
import BuildingImg from 'assets/business/u_building.svg'
import ChartLineImg from 'assets/business/u_chart-line.svg'
import PolygonImg from 'assets/business/u_polygon.svg'
import ShareImg from 'assets/business/fi_share-2.svg'
import UsersImg from 'assets/business/fi_users.svg'
import MapPinImg from 'assets/business/fi_map-pin.svg'
import GlobeImg from 'assets/business/fi_globe.svg'
import MailImg from 'assets/business/fi_mail.svg'
import PhoneImg from 'assets/business/fi_phone.svg'
import FaxImg from 'assets/business/fax.svg'
import api from 'api'
import { BusinessAvatarSearch } from 'components/MyBusiness/BusinessAvatarSearch'
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots'

const Marker = () => (
  <LocationOnIcon
    sx={{
      fontSize: '40px',
    }}
    color="primary"
  />
)

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

function addDashes(phone) {
  phone = phone || ''
  phone = phone.replace(/\D[^.]/g, '')
  let firstPart = phone.slice(0, 3)
  let secondPart = phone.slice(3, 6)
  let thirdPart = phone.slice(6)
  if (firstPart && secondPart && thirdPart) {
    return firstPart + '-' + secondPart + '-' + thirdPart
  }
  if (firstPart && secondPart) {
    return firstPart + '-' + secondPart
  }
  return firstPart
}

const LinkTextStyle = styled(Box)(() => ({
  color: '#0373C9',
  fontWeight: 'bold',
  cursor: 'pointer',
  textDecoration: 'none',
  fontSize: '12px',
  fontFamily: 'poppins',
  '&:hover': {
    textDecoration: 'underline',
  },
}))

const LinkButton = styled(MuiButton)(() => ({
  fontSize: '14px',
  textTransform: 'none',
  fontWeight: 'bold',
  color: '#0A78CD',
  textDecoration: 'underline',
}))

const BusinessDetail = ({ onClose }) => {
  const navigate = useNavigate()
  const userInfo = useSelector(state => state.userReducer)
  const [selectedBusinessData, setselectedBusinessData] = useState()
  const [loading, setloading] = useState()
  const dispatch = useDispatch()
  const businessReducer = useSelector(state => state.businessReducer)
  const { selectedBusiness, monitoredCompanies, snakBarData } = businessReducer
  const isclaimed = selectedBusiness?.claimedAt ? selectedBusiness?.ext_id : selectedBusiness?.businessId

  async function getBusinessDetail() {
    setloading(true)
    const check = isclaimed
    const data = await api.getBusinessDetails(check)
    setselectedBusinessData(data)
    setloading(false)
  }

  useEffect(() => {
    getBusinessDetail()
    // eslint-disable-next-line
  }, [])

  React.useEffect(() => {
    if (!selectedBusiness) {
      navigate('/find')
    }
    window.scrollTo(0, 0)
  }, [navigate, selectedBusiness])
  
  const isEditable =
    userInfo.user && userInfo.user.businessIds && userInfo.user.businessIds.length
      ? userInfo.user.businessIds.includes(selectedBusinessData?.details?.businessId)
      : false
  const isFreeAccount = userInfo?.user?.accountType !== 'premium'
  const { details } = selectedBusinessData || { details: null }

  const socialArr =
    (details && details?.socialTwitter) ||
    details?.socialFacebook ||
    details?.socialLinkedIn ||
    details?.socialInstagram
  const isMonitored = monitoredCompanies.monitorCompanyIds.includes(selectedBusiness?.ext_id || selectedBusiness)

  const handleMonitor = add => {
    updateMonitoredBusiness(dispatch, {
      addIds: add ? [selectedBusiness?.ext_id || selectedBusiness] : [],
      removeIds: add ? [] : [selectedBusiness?.ext_id || selectedBusiness],
    })
  }
  const onKeyPress = React.useCallback(
    event => {
      if (event.code === 'Escape') {
        onClose ? onClose() : navigate(-1)
      }
    },
    [onClose, navigate],
  )

  React.useEffect(() => {
    window.addEventListener('keydown', onKeyPress)
    return () => {
      window.removeEventListener('keydown', onKeyPress)
    }
  }, [onKeyPress])

  const handleClose = () => {
    handleNotifications(dispatch, {
      open: false,
      message: '',
      type: '',
    })
  }

  return (
    <>
      <MainLayout>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="80vh">
            <ThreeDotsLoadingSpinner width="70px" />
          </Box>
        ) : (
          <Box>
            {/* <IdleTimer maxIdleTime={process.env['REACT_APP_MAX_IDLE_TIME_DASHBOARD']} /> */}
            {selectedBusinessData && (
              <Box className="businessDetails" color="#25245f">
                <Box className="d-flex justify-content-end align-items-center p-4">
                  <LinkButton onClick={() => (onClose ? onClose() : navigate(-1))} variant="text">
                    Exit Business Details
                  </LinkButton>
                </Box>
                <Container className="mt-3">
                  <Grid container spacing={5}>
                    <Grid item xs md="auto">
                      <BusinessAvatarSearch
                        model={selectedBusinessData}
                        height={180}
                        width={180}
                        details
                      ></BusinessAvatarSearch>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Box display="flex" justifyContent="space-between" flexDirection="column">
                        <Box style={{ wordBreak: 'break-word' }}>
                          <Typography variant="h5" color="#0A78CD">
                            {details.businessName || selectedBusinessData.company}
                          </Typography>
                          <Box display={'flex'} gap="7px" className="py-1">
                            <img src={MapPinImg} alt="map" />
                            <Typography variant="body2" sx={{ marginLeft: '5px' }}>
                              {`
                                            ${details.addressStreet || selectedBusinessData.address}
                                            ${details.addressCity || selectedBusinessData.city}, 
                                            ${
                                              details.addressState ||
                                              selectedBusinessData.state ||
                                              selectedBusinessData.region
                                            }, 
                                            ${details.addressZip || selectedBusinessData.zip},
                                            ${details.addressCountry || selectedBusinessData.country || ''}`}
                            </Typography>
                          </Box>
                          {details.website || selectedBusinessData.web ? (
                            <Box display={'flex'} gap="7px" alignItems="center" className="py-1">
                              <img src={GlobeImg} alt="map" />
                              <LinkText
                                href={
                                  (details.website || selectedBusinessData.web).includes('http')
                                    ? details.website || selectedBusinessData.web
                                    : `https://${details.website || selectedBusinessData.web}`
                                }
                                variant="body2"
                                target="_blank"
                                sx={{ textDecoration: 'none' }}
                              >
                                <LinkTextStyle>{details.website || selectedBusinessData.web}</LinkTextStyle>
                              </LinkText>
                            </Box>
                          ) : null}
                          {details.businessPhone && (
                            <Box display={'flex'} gap="7px" alignItems="center" className="py-1">
                              <img src={PhoneImg} alt="map" />
                              <LinkText
                                href={`tel:${details.businessPhone}`}
                                variant="body2"
                                sx={{ textDecoration: 'none' }}
                              >
                                <LinkTextStyle>{addDashes(details.businessPhone)}</LinkTextStyle>
                              </LinkText>
                            </Box>
                          )}
                          {details.businessFax || selectedBusinessData.fax ? (
                            <Box display={'flex'} gap="7px" alignItems="center" className="py-1">
                              <img src={FaxImg} alt="map" />
                              <LinkText
                                href={`tel:${details.businessFax || selectedBusinessData.fax}`}
                                variant="body2"
                                sx={{ textDecoration: 'none' }}
                              >
                                <LinkTextStyle>
                                  {addDashes(details.businessFax || selectedBusinessData.fax)}
                                </LinkTextStyle>
                              </LinkText>
                            </Box>
                          ) : null}
                          {details.businessEmail || selectedBusinessData.email ? (
                            <Box display={'flex'} gap="7px" alignItems="center" className="py-1">
                              <img src={MailImg} alt="map" />
                              <LinkText
                                href={`mailto:${details.businessEmail || selectedBusinessData.email}`}
                                variant="body2"
                                sx={{ textDecoration: 'none' }}
                              >
                                <LinkTextStyle>{details.businessEmail || selectedBusinessData.email}</LinkTextStyle>
                              </LinkText>
                            </Box>
                          ) : null}
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {isFreeAccount ? (
                          <>
                            <Box
                              sx={{
                                display: 'flex',
                              }}
                            >
                              <Button type={DISABLED_BUTTON} sx={{ marginBottom: '10px', width: '250px' }}>
                                Follow
                              </Button>
                              <ButtonTooltip
                                placement="top"
                                width="320px"
                                arrow
                                title={
                                  <Box sx={{ textAlign: 'center' }}>
                                    <Typography component="span" variant="body2" color="white">
                                      A&nbsp;
                                    </Typography>
                                    <LinkText
                                      underline="hover"
                                      sx={{ cursor: 'pointer', textDecorationColor: 'white !important' }}
                                    >
                                      <Typography
                                        component="span"
                                        variant="button2"
                                        color="white"
                                        onClick={() => navigate('/welcome')}
                                      >
                                        subscription
                                      </Typography>
                                    </LinkText>
                                    <Typography component="span" variant="body2" color="white">
                                      &nbsp;is required to follow businesses.
                                    </Typography>
                                  </Box>
                                }
                              >
                                <InfoOutlinedIcon
                                  sx={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', color: '#0099FF' }}
                                />
                              </ButtonTooltip>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                              }}
                            >
                              <Button
                                fullWidth
                                onClick={() => navigate('/welcome')}
                                sx={{ marginBottom: '10px', width: '250px' }}
                              >
                                Upgrade Your Account
                              </Button>
                              <ButtonTooltip
                                placement="top"
                                width="320px"
                                arrow
                                title={
                                  <Box>
                                    <Typography variant="body2" component="span">
                                      Become a premium member to claim and verify your own business, display additional
                                      fields on your business page, boost your profile and monitor the businesses you’re
                                      interested in.&nbsp;
                                      <LinkText
                                        underline="hover"
                                        sx={{ textDecorationColor: 'white !important', cursor: 'pointer' }}
                                        onClick={() => navigate('/welcome')}
                                      >
                                        <Typography variant="body2B" component="span" color="white">
                                          Click here to get started
                                        </Typography>
                                      </LinkText>
                                      .
                                    </Typography>
                                  </Box>
                                }
                              >
                                <InfoOutlinedIcon
                                  sx={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', color: '#0099FF' }}
                                />
                              </ButtonTooltip>
                            </Box>
                          </>
                        ) : isEditable ? (
                          <Button
                            type={PRIMARY_BUTTON}
                            style={{ width: '250px' }}
                            className="mb-2 btnPrimary"
                            onClick={() => navigate('/correct-your-data')}
                          >
                            Edit Information
                          </Button>
                        ) : isMonitored ? (
                          <Button
                            type={PRIMARY_BUTTON}
                            sx={{ marginBottom: '10px', width: '250px' }}
                            onClick={() => handleMonitor(false)}
                          >
                            Unfollow
                          </Button>
                        ) : (
                          <Button
                            type={PRIMARY_BUTTON}
                            style={{ width: '250px' }}
                            className="mb-2 btnPrimary"
                            onClick={() => handleMonitor(true)}
                          >
                            Follow
                          </Button>
                        )}
                        {!isFreeAccount && !selectedBusinessData.details.claimedAt && (
                          <>
                            <div>
                              <Button style={{ width: '250px' }} onClick={() => navigate('/claim')}>
                                Claim Your Business
                              </Button>
                              <ButtonTooltip
                                placement="top"
                                width="320px"
                                style={{ position: 'absolute' }}
                                arrow
                                title={
                                  <Box>
                                    <Typography variant="body2" component="span">
                                      Claim and verify your own business to display additional fields and boost your
                                      profile for potential suppliers, partners and customers to see.
                                    </Typography>
                                  </Box>
                                }
                              >
                                <InfoOutlinedIcon
                                  sx={{ fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', color: '#0099FF' }}
                                />
                              </ButtonTooltip>
                            </div>
                          </>
                        )}
                        {selectedBusinessData.details.claimedAt && (
                          <Typography variant="body2" className="text-center" style={{ marginTop: '10%' }}>
                            Is this your business? To dispute or change ownership, let us know:{' '}
                            <LinkText
                              target="_blank"
                              rel="noreferrer"
                              underline="hover"
                              href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
                            >
                              <Typography component="span" variant="body2B" color="secondary">
                                support@markaaz.com
                              </Typography>
                            </LinkText>
                          </Typography>
                        )}
                        {isFreeAccount && !selectedBusinessData.details.claimedAt && (
                          <>
                            <div>
                              <Button sx={{ width: '250px' }} onClick={() => navigate('/claim')}>
                                Claim Your Business
                              </Button>
                              <ButtonTooltip
                                placement="top"
                                width="320px"
                                arrow
                                title={
                                  <Box>
                                    <Typography variant="body2" component="span">
                                      Claim and verify your own business to display additional fields and boost your
                                      profile for potential suppliers, partners and customers to see.
                                    </Typography>
                                  </Box>
                                }
                              >
                                <InfoOutlinedIcon
                                  sx={{
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    color: '#0099FF',
                                    marginBottom: '25px',
                                  }}
                                />
                              </ButtonTooltip>
                            </div>
                            <Typography variant="body2" style={{ marginTop: '10%', textAlign: 'left' }}>
                              Not ready to join the Markaaz community but want to update information on your business
                              profile? Please fill out a ticket by clicking the words “
                              <LinkText
                                style={{
                                  color: '#0A78CD',
                                }}
                                href="https://share.hsforms.com/1n5-LEIiqTUyScicS-czMBAcdn4z"
                                rel="noreferrer"
                                target="_blank"
                                underline="hover"
                              >
                                <Typography component="span" variant="body2B" color="secondary">
                                  contact us
                                </Typography>
                              </LinkText>
                              ” and we will work with you to update it.
                            </Typography>
                          </>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                  <Divider className="mt-5" variant="fullWidth" component="div" />
                  <Grid container spacing={5} className="pt-5" style={{ minHeight: '420px' }}>
                    <Grid item xs={12} md={7}>
                      <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <img src={BuildingImg} alt="Company Overview" style={{ paddingRight: '10px' }} />
                          <Typography variant="h6">Company Overview</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <CompanyOverview isFreeAccount={isFreeAccount} data={selectedBusinessData} />
                        </AccordionDetails>
                      </Accordion>
                      <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <img src={DollarSignImg} alt="Financial" style={{ paddingRight: '10px' }} />
                          <Typography variant="h6">Financial</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <FinancialComponent isFreeAccount={isFreeAccount} data={selectedBusinessData} />
                        </AccordionDetails>
                      </Accordion>

                      {details.category || selectedBusinessData.sic ? (
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <img src={PolygonImg} alt="Industry" style={{ paddingRight: '10px' }} />
                            <Typography variant="h6">Industry</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Box display={'flex'} gap="7px" alignItems="baseline">
                              <Box display="flex" flexDirection="column">
                                <Typography className="py-1" variant="body2">
                                  {details.category || selectedBusinessData.sic}
                                </Typography>
                              </Box>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                      ) : null}

                      <Accordion>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <img src={ChartLineImg} alt="Business Health Metrics™" style={{ paddingRight: '10px' }} />
                          <Typography variant="h6">Business Health Metrics™</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <HealthMetricsComponent data={selectedBusinessData} isFreeAccount={isFreeAccount} />
                        </AccordionDetails>
                      </Accordion>

                      {/* {!isFreeAccount && (details.keyPeople || details.beneficialOwner) && (
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <img src={UsersImg} alt="Business Health Metrics™" style={{ paddingRight: '10px' }} />
                            <Typography variant="h6">Management & Ownership</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <KeyPeople data={selectedBusinessData} />
                          </AccordionDetails>
                        </Accordion>
                      )} */}

                      {selectedBusinessData.details.claimedAt &&
                        (details?.keyPeople?.filter(person => person.displayInDirectory)?.length > 0 ||
                          details?.beneficialOwners?.length > 0) && (
                          <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <img src={UsersImg} alt="Business Health Metrics™" style={{ paddingRight: '10px' }} />
                              <Typography variant="h6">Management & Ownership</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <KeyPeople data={selectedBusinessData} />
                            </AccordionDetails>
                          </Accordion>
                        )}

                      {socialArr && (
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <img src={ShareImg} alt="Business Health Metrics™" style={{ paddingRight: '10px' }} />
                            <Typography variant="h6">Social</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <SocialComponent data={selectedBusinessData} isFreeAccount={isFreeAccount} />
                          </AccordionDetails>
                        </Accordion>
                      )}

                      {selectedBusinessData.details.claimedAt && (
                        <Accordion>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <img
                              style={{ marginRight: '9px' }}
                              src={
                                process.env['REACT_APP_DIRECTORY_SERVICE_URL'] + '/static/media/mkx_logo.3a1f5833.png'
                              }
                              width="20"
                              height="20"
                              alt="logo"
                            />

                            <Typography variant="h6">Markaaz</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <MarkaazBusinessComponent isFreeAccount={isFreeAccount} details={details} />
                          </AccordionDetails>
                        </Accordion>
                      )}
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <Box style={{ height: '400px' }}>
                        <GoogleMapReact
                          bootstrapURLKeys={{
                            key: 'AIzaSyDTKgH4OE2jTGgoJU8z1ak_hheQs_C65go',
                            libraries: ['places'],
                          }}
                          defaultCenter={{
                            lat: Number(details?.addressLat || 0),
                            lng: Number(details?.addressLon || 0),
                          }}
                          defaultZoom={15}
                        >
                          <Marker lat={details?.addressLat} lng={details?.addressLon} />
                        </GoogleMapReact>
                      </Box>
                    </Grid>
                  </Grid>
                </Container>
              </Box>
            )}

            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={snakBarData.open}
              autoHideDuration={5000}
              onClose={handleClose}
            >
              <Alert
                role="alert"
                onClose={handleClose}
                severity={snakBarData.type}
                sx={{ width: '100%', fontSize: '14px' }}
              >
                {snakBarData.message}
              </Alert>
            </Snackbar>
            <Box
              display="flex"
              color="#66668F"
              justifyContent="space-between"
              textAlign="left"
              borderTop="1px solid #CEE4F5"
              padding="10px"
              marginTop="10px"
            >
              <Typography variant="caption" sx={{ margin: '16px 0px 0px 8px' }}>
                Data Methodology&nbsp;
                <Tooltip
                  placement="top-center"
                  content={
                    <Typography variant="body2" color="white">
                      Markaaz Directory data is curated from global premium and public sources, including Equifax,
                      public records, and user contributory processes.
                      <br />
                      <br />
                      Our proprietary technology verifies and updates this data daily from our global network.
                      <br />
                      <br />
                      <LinkText
                        href="https://support.markaaz.com/knowledge/data-methodology"
                        rel="noreferrer"
                        target="_blank"
                        underline="hover"
                        sx={{
                          display: 'inline',
                          marginLeft: '4px',
                          textDecorationColor: 'white !important',
                        }}
                      >
                        <Typography component="span" variant="body2B" color="white">
                          Learn more
                        </Typography>
                      </LinkText>{' '}
                      about our data methodology.
                    </Typography>
                  }
                >
                  <InfoOutlinedIcon fontSize="16px" color="#0099FF" className="k-cursor-pointer" />
                </Tooltip>
              </Typography>
              <ZendeskLink />
            </Box>
            <LinkText underline="hover" target="_blank" href="https://clearbit.com/" fontStyle="normal">
              <Typography variant="button3" color="white">
                <LinkTextStyle sx={{ paddingLeft: '18px' }}>Logos provided by Clearbit</LinkTextStyle>
              </Typography>
            </LinkText>
            <Typography style={{ visibility: 'hidden' }} variant="body2">
              Hidden Text
            </Typography>
          </Box>
        )}
      </MainLayout>
    </>
  )
}

export default BusinessDetail
